import React, { Component } from 'react';
import { connect } from 'react-redux';
import PointRankingListWrap from '../../views/point/ranking/PointRankingListWrap';
import { pointActions } from '../../store/modules/point';
import {
  POINT_RANKING_LIST_SEARCH_OPTION_MODEL,
  POINT_RANKING_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/point/models';
import { _LIST_PAGINATION_MODEL } from '../../store/modules/app/models';

class PointRankingListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   *  credit 이 많은 순으로 정렬
   */
  initiate = () => {
    this.getList({
      searchOption: POINT_RANKING_LIST_SEARCH_OPTION_MODEL,
      sortOption: POINT_RANKING_LIST_SORT_OPTION_MODEL,
      pagination: _LIST_PAGINATION_MODEL,
    });
  };

  /**
   * list 조건에 따라 받아오기
   */
  getList = (data) => {
    const { getPointRanking, pointRanking } = this.props;
    const { searchOption, sortOption, pagination } = pointRanking;

    getPointRanking({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   *  포인트 랭킹 리스트 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getPointRankingListExcelDownload, pointRanking } = this.props;
    const { searchOption, sortOption } = pointRanking;

    getPointRankingListExcelDownload({
      searchOption,
      sortOption,
    });
  };

  render() {
    const { setData, pointRanking, toggleModal } = this.props;

    return (
      <PointRankingListWrap
        setData={setData}
        pointRanking={pointRanking}
        getExcelDownload={this.getExcelDownload}
        getList={this.getList}
        toggleModal={toggleModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    pointRanking: state.point.pointRanking,
  };
};

const mapDispatchToProps = {
  setData: pointActions.setData,
  getPointRanking: pointActions.getPointRanking,
  getPointRankingListExcelDownload: pointActions.getPointRankingListExcelDownload,
  toggleModal: pointActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(PointRankingListContainer);
